import React, { useEffect, useState } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import AttachmentsAHSF from "../../../Components/AttachmentsAHSF";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAttachmentsByPermissions,
  SetAttachments,
} from "../../../Redux/Reducers/Attachments";
import { GetBeneficiaryInformation } from "../../../Redux/Reducers/BeneficiaryInformation";
import UpdateAttachments from "../../../Services/Attachments/UpdateAttachments";
import axios from "axios";
import loadConfig from "../../../Services/apiService";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import LoaderAHSF from "../../../Components/LoaderAHSF";

function AttachmentsPage() {
  const AppGuid = useParams();
  const [attachments, setAttachments] = useState([]);
  const [refreshData, setrefreshData] = useState(false);
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      BeneficiaryInformationLoading:
        state.BeneficiaryInformation.loadingBeneficiaryInformation,
      Attachments: state.Attachments.Attachments,
      loadingAttachments: state.Attachments.loadingAttachments,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  //[,]
  //to get BeneficiaryInformation data by guid from localstorge or params
  useEffect(() => {
    dispatch(
      GetBeneficiaryInformation(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);
  //[,]
  //اذا كانت  نوع المستفيد موجود بجيب الملفات
  //وبتكون اجباري او لا حسب نوع المستفيد
  useEffect(() => {
    if (state.BeneficiaryInformation) {
      dispatch(
        GetAttachmentsByPermissions({
          applicantTypeId: state.BeneficiaryInformation.aI_ApplicantTypeId,
          aI_ApplicationInformationId:state.ApplicationInformation.aI_ApplicationInformationId ||
            decryptToken(AppGuid.AppGuid),
        })
      );
    }
  }, [state.BeneficiaryInformation, refreshData]);
    // Update the local state `attachments` with the current attachments from Redux state
  useEffect(() => {
    if (state.loadingAttachments && state.Attachments) {
      setAttachments([...state.Attachments]);
    }
  }, [state.loadingAttachments, state.Attachments]);
  // Dispatch the current attachments from the local state to Redux
  useEffect(() => {
    dispatch(SetAttachments([...attachments]));
  }, [attachments]);
  

  const shouldDisableFields = !(
    //[,]
    // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
    (
      state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      window.location.href.includes("manager") == false
    )
  );
  //to render html after loding ends
 
  
  return state.Attachments  ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="المرفقات والتعهد"
        child={
          state.Attachments && state.Attachments.length != 0 ? (
            state.Attachments.map((attachment, index) => (
              <div className="form-grid" key={attachment.id}>
                <p>
                  {attachment.aC_AttachementTypes.attachementName}
                  {attachment.isRequierd && <span className="star">*</span>}
                </p>
                <AttachmentsAHSF
                  id={`file${index}`}
                  // text={attachment.aC_AttachementTypes.attachementName}
                  // title={attachment.aC_AttachementTypes.attachementName}
                  text={"انقر لتعديل المرفق"}
                  title={"انقر لتعديل المرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  readOnly={false}
                  singleFile={attachment.attachmentData}
                  AttachementType={attachment.aC_AttachementTypes.folderName}
                  onChange={(e) => {
                    //console.log(e.target.files[0],"fileeeeeeeeeeeeeee");

                    // UpdateAttachments({
                    //   file: e.target.files[0],
                    //   fileName: attachment.aC_AttachementTypes.folderName,
                    //   aC_AttachementTypesId: attachment.aC_AttachementTypesId,
                    //   aI_ApplicationInformationId:
                    //     attachment.aI_ApplicationInformationId,
                    // });

                    
                    // setLoading(true)
                    // setrefreshData(false);

                   

                    axios
                      .post(
                        `${dataJsonObject.domainUrl}/api/Attachments/UpdateAttachments`,
                        {
                          file: e.target.files[0],
                          fileName: attachment.aC_AttachementTypes.folderName,
                          aC_AttachementTypesId:
                            attachment.aC_AttachementTypesId,
                          aI_ApplicationInformationId:
                            attachment.aI_ApplicationInformationId,
                        },
                        {
                          headers: {
                            "Content-Type": "multipart/form-data",
                          },
                        }
                      )
                      .then((res) => {
                        // console.log(res, "RESSSSSSSSSSSSSSSSSSSSS");
                        if (res.data.success) {

                          setLoading(false)
                        

                        }
                        setrefreshData(true);
                      })
                      .catch((err) => {
                        //console.log(err);
                      });
                  }}
                />
              </div>
            ))
          ) : (
            <div className="form-nothing">لا يوجد مرفقات</div>
          )
        }
      />
      <LoaderAHSF show={loading||state.Attachments=="undefined"||state.Attachments==undefined||!state.Attachments?.length} />
    </>
  ) : (
    ""
  );
}

export default AttachmentsPage;
